import type { Reason } from './fleetMetrics.ts';
import styles from './ReasonList.module.css';

/* ==========================================================================
   ReasonList — why this row is in this list.

   `LABEL value` pairs: the metric's own name in the matrix's 10px uppercase
   mono, the reading beside it in the tone the threshold produced. The label
   is the same word the matrix row carries, so an operator who saw the amber
   cell in `BATT` finds `BATT 22%` here and knows it is the same reading.

   Not chips, not badges: this repeats on every row (THE BAR §8 tell #2), and
   coloured text is the encoding that scales past three.
   ========================================================================== */

export function ReasonList({ reasons }: { reasons: readonly Reason[] }) {
  return (
    <span className={styles.list}>
      {reasons.map((r) => (
        <span
          key={r.label}
          className={styles.reason}
          data-tone={r.tone}
          data-hollow={r.hollow}
        >
          <span className={styles.label}>{r.label}</span>
          <span className={styles.value}>{r.text}</span>
        </span>
      ))}
    </span>
  );
}
